import { Icon } from '@repo/foundations';

export const NormalIcon = (
	<Icon name="circleCheckFilled" size="md" fillColor="icon/success/default" />
);
export const ErrorIcon = (
	<Icon name="alertCircleFilled" size="md" fillColor="icon/critical/default" />
);
export const OpenIncidentsIcon = (
	<Icon name="circle" size="md" color="icon/warning/default" />
);
export const AcknowledgedIncidentsIcon = (
	<Icon name="progress50" size="md" color="icon/caution/default" />
);
export const BoltIcon = (
	<Icon name="bolt" size="md" color="icon/secondary/default" />
);
export const CircleCheckFilledIcon = (
	<Icon name="circleCheckFilled" size="md" fillColor="icon/secondary/default" />
);

export const AlertIcon = (
	<Icon name="alertTriangleFilled" size="md" fillColor="icon/warning/default" />
);

export const AccessRemovedIcon = (
	<Icon name="circleXFilled" size="md" fillColor="icon/primary/disabled" />
);
export const InReviewIcon = (
	<Icon name="progress75" size="md" color="icon/info/default" />
);

export const CostIcon = (
	<Icon name="coin" size="md" color="icon/secondary/default" />
);

export const CodeIcon = (
	<Icon name="code" size="md" color="icon/secondary/default" />
);

export const ClockIcon = (
	<Icon name="clock" size="md" color="icon/secondary/default" />
);
